module.exports = __webpack_public_path__ + "img/全日制@2x.8ee01ab1.png";